<fui-link-button (click)="openEditLink($event)" [title]="dataItem | property: field"></fui-link-button>
